<div class="form-container" [formGroup]="form" *ngIf="translations">
  <div [formArrayName]="'units'">
    <div
      *ngFor="let unit of units.controls; index as i"
      [formGroupName]="i"
      class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12"
      [@addRemoveAnimation]>
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 inner-unit-container">
        <app-review-section
          #unitSection
          [title]="translations.unitHeader + ' ' + (i + 1)"
          [applicationId]="applicationId"
          [sectionId]="SectionIdentifier.DrrCcd_TechnicalData_Unit"
          [entityId]="unit.value.id"
          [deletable]="units?.value.length > 1"
          (delete)="removeUnit(i)"
          [isDetailsView]="isDetailsView"
          [hasBorders]="true">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 form-container">
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="unitControls.unavailable.visible">
              <app-checkbox
                [label]="unitControls.unavailable.label()"
                [formControl]="unit.controls.unavailable"
                [forceDisable]="!unitSection.isDataEditable"></app-checkbox>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="unitControls.manufacturer.visible">
              <app-input
                [label]="'drr-ccd-devices.manufacturer-of-device-lbl' | translate"
                [formControl]="unit.controls.manufacturer"
                [forceDisable]="!unitSection.isDataEditable"></app-input>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="unitControls.designationType.visible">
              <app-input
                [label]="'drr-ccd-devices.type-designation-lbl' | translate"
                [formControl]="unit.controls.designationType"
                [forceDisable]="!unitSection.isDataEditable"></app-input>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="unitControls.electricalPower.visible">
              <app-input-number
                [label]="'drr-ccd-devices.electrical-power-lbl' | translate"
                [formControl]="unit.controls.electricalPower"
                [forceDisable]="!unitSection.isDataEditable"></app-input-number>
            </div>

            <!-- upload-data-sheet storage -->
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showUploadDataSheetStorage">
              <app-file-input-form-control
                [label]="'drr-ccd-devices.upload-data-sheet' | translate"
                [data]="unit.controls.dataSheetRawValue?.value"
                documentType="drr_ccd_data_sheet"
                [required]="true"
                [disabled]="unit.value.unavailable || !showUploadDataSheetStorage || !unitSection.isDataEditable"
                (formInited)="fileFormInited($event, unit, 'dataSheet')"
                [clearOn]="unit.controls.unavailable.valueChanges"></app-file-input-form-control>
            </div>

            <!-- upload-circuit-diagram-document -->
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showUploadCircuitDiagram">
              <app-file-input-form-control
                [label]="'drr-ccd-devices.upload-circuit-diagram' | translate"
                [data]="unit.controls.circuitDiagramRawValue?.value"
                documentType="drr_ccd_circuit_diagram"
                [required]="true"
                [disabled]="unit.value.unavailable || !showUploadCircuitDiagram || !unitSection.isDataEditable"
                (formInited)="fileFormInited($event, unit, 'circuitDiagramDocument')"
                [clearOn]="unit.controls.unavailable.valueChanges"></app-file-input-form-control>
            </div>

            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="unitControls.powerOfAdditionalHeater.visible">
              <app-input-number
                [label]="'drr-ccd-devices.power-of-additional-heater-lbl' | translate"
                [formControl]="unit.controls.powerOfAdditionalHeater"
                [forceDisable]="!unitSection.isDataEditable"></app-input-number>
            </div>
          </div>

          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 form-container">
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="unitControls.hasAdditionalHeating.visible">
              <app-radio-button-yes-no
                [name]="'hasAdditionalHeating_' + unit.controls.id.value + '_' + i"
                [label]="'drr-ccd-devices.additional-heating-lbl' | translate"
                [formControl]="unit.controls.hasAdditionalHeating"
                [forceDisable]="!unitSection.isDataEditable"
                [style]="'horizontal'"></app-radio-button-yes-no>
            </div>

            <!-- loadManagementAvailable -->
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="unitControls.loadManagementAvailable.visible">
              <app-radio-button-yes-no
                [name]="'loadManagementAvailable_' + unit.controls.id.value + '_' + i"
                [label]="'drr-ccd-devices.load-management-available' | translate"
                [formControl]="unit.controls.loadManagementAvailable"
                [forceDisable]="!unitSection.isDataEditable"
                [style]="'horizontal'"></app-radio-button-yes-no>
            </div>

            <!-- loadManagementType -->
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showLoadManagementType(i)">
              <app-drop-down
                [label]="'drr-ccd-devices.information-about-load-management-lbl' | translate"
                [options]="loadManagementTypeOptions"
                [formControl]="unit.controls.loadManagementType"
                [forceDisable]="!unitSection.isDataEditable"></app-drop-down>
            </div>

            <!-- couplingType -->
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="unitControls.couplingType.visible">
              <app-drop-down
                [label]="'drr-ccd-devices.coupling-type-lbl' | translate"
                [options]="couplingTypeOptions"
                [formControl]="unit.controls.couplingType"></app-drop-down>
            </div>

            <!-- upload-data-sheet -->
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showUploadUnitDataSheet(i)">
              <app-file-input-form-control
                [label]="'drr-ccd-devices.upload-data-sheet' | translate"
                [data]="unit.controls.dataSheetRawValue?.value"
                documentType="drr_ccd_data_sheet"
                [required]="true"
                [disabled]="unit.value.unavailable || !showUploadUnitDataSheet(i) || !unitSection.isDataEditable"
                (formInited)="fileFormInited($event, unit, 'dataSheet')"
                [clearOn]="unit.controls.unavailable.valueChanges"></app-file-input-form-control>
            </div>

            <!-- upload-data-sheet-WR -->
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showUploadDataSheetWr(i)">
              <app-file-input-form-control
                [label]="'drr-ccd-devices.upload-data-sheet-wr-lbl' | translate"
                [data]="unit.controls.dataSheetRwRawValue?.value"
                documentType="drr_ccd_data_sheet_wr"
                [required]="true"
                [disabled]="unit.value.unavailable || !showUploadDataSheetWr(i) || !unitSection.isDataEditable"
                [clearOn]="unit.controls.unavailable.valueChanges"
                (formInited)="fileFormInited($event, unit, 'dataSheetWr')"></app-file-input-form-control>
            </div>
          </div>

          <div formArrayName="subUnits" id="sub-units-container" *ngIf="unit?.controls.subUnits">
            <div
              *ngFor="let subUnit of unit?.controls.subUnits?.controls; index as ii"
              [formGroupName]="ii"
              [id]="'subunit-' + ii"
              class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 nested-item-lev"
              [@addRemoveAnimation]>
              <app-review-section
                #subUnitSection
                [title]="translations.subUnitHeader + ' ' + (ii + 1)"
                [applicationId]="applicationId"
                [sectionId]="SectionIdentifier.DrrCcd_TechnicalData_SubUnit"
                [entityId]="subUnit.value.id"
                [deletable]="unit.value.subUnits?.length > 1"
                [isDetailsView]="isDetailsView"
                (delete)="removeSubUnit(unit, ii)">
                <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 form-container">
                  <!-- outer-unit-unavailable -->
                  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="subUnitControls.unavailable.visible && ii === 0">
                    <app-checkbox
                      [label]="subUnitControls.unavailable.label()"
                      [formControl]="subUnit.controls.unavailable"
                      [forceDisable]="!subUnitSection.isDataEditable"></app-checkbox>
                  </div>

                  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="subUnitControls.manufacturer.visible">
                    <app-input
                      [label]="'drr-ccd-devices.manufacturer-of-device-lbl' | translate"
                      [formControl]="subUnit.controls.manufacturer"
                      [forceDisable]="!subUnitSection.isDataEditable"></app-input>
                  </div>

                  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="subUnitControls.designationType.visible">
                    <app-input
                      [label]="'drr-ccd-devices.type-designation-lbl' | translate"
                      [formControl]="subUnit.controls.designationType"
                      [forceDisable]="!subUnitSection.isDataEditable"></app-input>
                  </div>

                  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="subUnitControls.electricalPower.visible">
                    <app-input-number
                      [label]="'drr-ccd-devices.electrical-power-lbl' | translate"
                      [formControl]="subUnit.controls.electricalPower"
                      [forceDisable]="!subUnitSection.isDataEditable"></app-input-number>
                  </div>

                  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="subUnitControls.powerOfAdditionalHeater.visible">
                    <app-input-number
                      [label]="'drr-ccd-devices.power-of-additional-heater-lbl' | translate"
                      [formControl]="subUnit.controls.powerOfAdditionalHeater"
                      [forceDisable]="!subUnitSection.isDataEditable"></app-input-number>
                  </div>
                </div>

                <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 form-container" [formGroup]="subUnit">
                  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="subUnitControls.hasAdditionalHeating.visible">
                    <app-radio-button-yes-no
                      [name]="'subUnitHasAdditionalHeating_' + unit.controls.id.value + '_' + i + '_' + ii"
                      [label]="'drr-ccd-devices.additional-heating-lbl' | translate"
                      [formControl]="subUnit.controls.hasAdditionalHeating"
                      [forceDisable]="!subUnitSection.isDataEditable"
                      [style]="'horizontal'"></app-radio-button-yes-no>
                  </div>

                  <!-- upload-data-sheet -->
                  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="showUploadSubUnitDataSheet(unit, ii)">
                    <app-file-input-form-control
                      [label]="'drr-ccd-devices.upload-data-sheet' | translate"
                      [data]="subUnit.controls.dataSheetRawValue?.value"
                      documentType="drr_ccd_data_sheet"
                      [required]="true"
                      [disabled]="subUnit.value.unavailable || !showUploadSubUnitDataSheet(unit, ii) || !subUnitSection.isDataEditable"
                      [clearOn]="subUnit.controls.unavailable.valueChanges"
                      (formInited)="fileFormInited($event, subUnit, 'dataSheet')"></app-file-input-form-control>
                  </div>
                </div>
              </app-review-section>
            </div>
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 nested-item-lev" *ngIf="unitControls.subUnits.visible">
              <app-plus-button
                *ngIf="allowAddSubUnit"
                id="add-subunit-btn"
                [label]="getSubUnitLabel(i + 1)"
                (onClick)="addSubUnit(unit)"></app-plus-button>
            </div>
          </div>
        </app-review-section>
      </div>
    </div>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12" *ngIf="ccdType">
      <app-plus-button *ngIf="allowAddUnit" id="add-unit-btn" [label]="unitAddLabel" (onClick)="addUnit(null)"></app-plus-button>
    </div>
  </div>
</div>
